import { DataGetter } from '@rea-argonaut/analytics';
import { User } from '@property.com.au/argonaut';

interface UserTrackingData {
  user_login_status: 'logged_in' | 'not_logged_in';
  locke_id?: string | null;
  pcauid?: string | null;
  country_code?: string | null;
}

export const getLoggedOutUserDataGetter =
  (user: User): DataGetter =>
  (): {
    user: {
      schema: `iglu:au.com.realestate/user/jsonschema/${string}`;
      data: UserTrackingData;
    };
  } => ({
    user: {
      schema: 'iglu:au.com.realestate/user/jsonschema/2-0-6',
      data: {
        user_login_status: 'not_logged_in',
        locke_id: null,
        pcauid: user.pcauid ?? null,
        country_code: user.countryCode ?? null,
      },
    },
  });
